import VBottomSheet from './VBottomSheet'

/* istanbul ignore next */
VBottomSheet.install = function install (Vue) {
  Vue.component(VBottomSheet.name, VBottomSheet)
}

export default VBottomSheet



// WEBPACK FOOTER //
// ./src/components/VBottomSheet/index.js